var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[(_vm.contractCurrent)?_c('Before'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }